import ReceiptPaymentModeSummary from "@/components/receipt-payment-summary/ReceiptPaymentModeSummary";
import {
  buildRentSummaryQuery,
  RENT_PAYMENT_SUMMARY_PATH,
  RENT_SUMMARY_QUERY_KEYS,
  rentPaymentSummaryCardsFromResponse,
  shouldFetchRentPaymentSummary,
} from "./rent-booking-receipt-payment-summary";

export default function RentBookingReceiptPaymentSummary() {
  return (
    <ReceiptPaymentModeSummary
      apiResource="contRcpt"
      summaryPath={RENT_PAYMENT_SUMMARY_PATH}
      queryKeys={RENT_SUMMARY_QUERY_KEYS}
      shouldFetch={shouldFetchRentPaymentSummary}
      buildQuery={buildRentSummaryQuery}
      cardsFromResponse={rentPaymentSummaryCardsFromResponse}
    />
  );
}
